import * as React from 'react';
import { useTranslation } from 'react-i18next';

import { PageTitle } from './PageTitle.jsx';
import PlayerTag from './PlayerTag.jsx';

import { useApplication } from '../AppContext';
import { useOnline } from '../services/useOnline';

export const RoomTypes = {
	Find: 'Find a Game',
	Create: 'Private Room',
};

const OnlineMenu = () => {

	const { t } = useTranslation();
	const app = useApplication();
	const isOnline = useOnline();

	const menuOptions = React.useMemo(() => {
		return Object.entries(RoomTypes).map(([name, title]) => {
			return (
				<li key={name}>
					<a href={`#Online/${name}`} className="button buttonEasy">
						{t(title)}
					</a>
				</li>
			);
		});
	}, [t]);

	const content = React.useMemo(() => {
		if (!isOnline || !app.multiplayer) {
			return (
				<>
					<div>{t('You appear to be offline.')}</div>
					<div>{t('Please check your connection.')}</div>
				</>
			);
		}

		return (
			<ul className="buttonList">
				{menuOptions}
				<li>
					<PlayerTag showOnline />
				</li>
			</ul>
		);

	}, [isOnline, menuOptions, t, app]);

	return (

		<div id="OnlineMenu" className="page1">
			<div className="wrapper">
				<PageTitle>
					<h1>{t('Online')}</h1>
				</PageTitle>
				{content}

			</div>
		</div>
	);
};

export default React.memo(OnlineMenu);
